import _ from "lodash";
import { CCO, FEEDERLISTS } from "../_constants/actionConstants";

const initialState = {
  projCcoLists: {}, // Normalized by projectId
  openCcoDetails: {}, // Normalized by projectId, then by ccoId
  miscSessionData: {},
  fetching: false,
  updating: false,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CCO.FETCH_ALL:
    case CCO.FETCH_DETAILS:
      return { ...state, fetching: true };

    case CCO.FETCH_DETAILS_REJECTED:
    case CCO.FETCH_ALL_REJECTED:
      return { ...state, fetching: false };

    case CCO.ADD:
    case CCO.DELETE:
    case CCO.EDIT:
      return { ...state, updating: true };

    case CCO.ADD_FULFILLED:
    case CCO.ADD_REJECTED:
    case CCO.EDIT_REJECTED:
    case CCO.DELETE_FULFILLED:
    case CCO.DELETE_REJECTED:
      return { ...state, updating: false };

    case FEEDERLISTS.FETCH_FULFILLED:
    case CCO.FETCH_ALL_FULFILLED: {
      const { projectId, projCcoList } = action;
      if (!projectId) return { ...state, fetching: false };

      return {
        ...state,
        fetching: false,
        projCcoLists: {
          ...state.projCcoLists,
          [projectId]: projCcoList,
        },
      };
    }

    case CCO.EDIT_FULFILLED:
    case CCO.FETCH_DETAILS_FULFILLED: {
      const { projectId, ccoId, ccoDetails } = action;
      if (!projectId || !ccoId || !ccoDetails) return { ...state, fetching: false };

      return {
        ...state,
        fetching: false,
        openCcoDetails: {
          ...state.openCcoDetails,
          [projectId]: { ...state.openCcoDetails[projectId], [ccoId]: ccoDetails },
        },
      };
    }

    case CCO.CLEAR_DETAILS: {
      const { projectId, ccoId } = action;
      if (
        !projectId ||
        !ccoId ||
        !(projectId in state.openCcoDetails) ||
        !(ccoId in state.openCcoDetails[projectId])
      )
        return { ...state, fetching: false };

      let openCcoDetails = _.cloneDeep(state.openCcoDetails);
      delete openCcoDetails[projectId][ccoId];
      return { ...state, fetching: false, openCcoDetails };
    }

    default:
      return { ...state };
  }
};
